import { GetReq, Stage, Status, Type as RequestType } from '@/api/types/getReq';
import { NotificationsRes } from '@/api/types/notificationsType';

export const buildRequestFromNotification = (
  notification: NotificationsRes,
  requestsById: Record<number, GetReq>
): GetReq | undefined => {
  const requestId = notification.params?.request_id;

  if (!requestId) {
    return undefined;
  }

  if (requestsById[requestId]) {
    return requestsById[requestId];
  }

  if (notification.type !== 'USER_REGISTRATION') {
    return undefined;
  }

  return {
    id: requestId,
    status: Status.Pending,
    stage: Stage.Registration,
    type: RequestType.Registration,
    created_at: new Date(notification.created_at),
    updated_at: new Date(notification.updated_at),
    is_deleted: false,
    feedback: null,
    user_id: notification.user_id ?? notification.params?.user_id ?? 0,
    post_id: notification.post_id,
    user_name: String(notification.translation_params?.user_name ?? ''),
    user_university_id: '',
    user_gender: '',
    user_date_of_birth: '',
    user_email: String(notification.translation_params?.user_email ?? ''),
    post_title: notification.translation_params?.post_title
      ? String(notification.translation_params.post_title)
      : null,
    reviewers: [],
    has_unresolved_changes: false,
    assigned_admin_id: null,
    assigned_at: null,
    assigned_admin: null,
  };
};
